<nz-form-item class="mb-0">
  <nz-form-label *ngIf="field.label" [nzSpan]="labelCol" class="text-start">{{field.label}} <span *ngIf="field.required"
                                                                              class="text-danger">*</span>
  </nz-form-label>
  <nz-form-control [nzSpan]="controlCol">
    <nz-input-group
      *ngIf="field.suffixIcon || field.prefixIcon || suffixIcon || addOnAfter || addOnAfterIcon || addOnBefore || addOnBeforeIcon || prefixIcon || prefix || suffix; else controlTpl"
      [nzAddOnAfter]="addOnAfter" [nzAddOnAfterIcon]="addOnAfterIcon"
      [nzAddOnBefore]="addOnBefore" [nzAddOnBeforeIcon]="addOnBeforeIcon"
      [nzPrefix]="prefix" [nzPrefixIcon]="field.prefixIcon || prefixIcon"
      [nzSuffix]="suffix" [nzSuffixIcon]="field.suffixIcon || suffixIcon"
    >
      <ng-container [ngTemplateOutlet]="controlTpl"></ng-container>
    </nz-input-group>
  </nz-form-control>
</nz-form-item>
<ng-template #controlTpl>
  <ng-container [ngSwitch]="field.type">
    <ng-container *ngSwitchCase="formItemType.CHECKBOX">
      <label
        nz-checkbox [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"
        [nzDisabled]="field.disable">
      </label>
    </ng-container>
    <ng-container *ngSwitchCase="formItemType.INPUT_NUMBER">
      <input
        inputNumber class="w-100" nz-input type="text" vssUiAutoCplControl
        [vssUiAutocomplete]="field.field"
        [disabledAutoComplete]="!!field?.disableAutocomplete"
        [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"
        [maxlength]="field?.maxLength || 4000"
        [placeholder]="field.placeholder || field.label"
        (keyup.enter)="emitEvent(keyupEnter, $event)"
        (keyup)="emitEvent(keyup, $event)"
      >
    </ng-container>
    <ng-container *ngSwitchCase="colDateTypes.includes(field.type) ? field.type : -1">
      <vss-ui-date-picker
        dateFormat [ranges]="field.rangesDate"
        [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"
        [csShowToday]="true"
        [csRangePicker]="formItemType.DATE_RANGE_PICKER == field.type || formItemType.DATE_TIME_RANGE_PICKER == field.type"
        [csShowTime]="formItemType.DATE_TIME_RANGE_PICKER == field.type || formItemType.DATE_TIME_PICKER == field.type"
      ></vss-ui-date-picker>
    </ng-container>
    <ng-container
      *ngSwitchCase="formItemType.SELECT">
      <vss-ui-select-box #csSelectScrollComponent
                         [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"
                         [optionList]="field.options || []" [getOptionsApi]="field.apiSearch!"
                         [keySearch]="field.keySearch ||'keyword'" addressSelector
                         [asType]="field.addressSelectorType!"
                         [asReferenceId]="refId || null"
                         vssUiSelectDir
                         [selectOptionsType]="field.selectOptionsType!"
                         [csMaxTagCount]="field.csMaxTagCount!"
                         [params]="field.params!" (onClose)="null"
                         [csMode]="field.multiple ? 'multiple' : 'default'" fieldId="userName"
                         [csPlaceHolder]="field.placeholder || field.label"
                         [csAllowClear]="field.csAllowClear !== undefined ? field.csAllowClear! : true"
                         [csDropdownMatchSelectWidth]="true"></vss-ui-select-box>
    </ng-container>
    <ng-container *ngSwitchCase="formItemType.TEXTAREA">
                    <textarea
                      rows="4" nz-input
                      [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"
                      [placeholder]="field.placeholder || field.label"
                      [attr.maxlength]="field.maxLength || MAX_LENGTH_TEXT"
                      #inputTextareaRef
                      (keyup)="emitEvent(keyup, $event)"
                    ></textarea>
    </ng-container>
    <ng-container *ngSwitchCase="formItemType.RANGE_NUMBER">
      <vss-ui-range-number [minValue]="field.minValue || 0" [maxValue]="field.maxValue || 100"
                           [suffix]="field.suffix || ''" [classes]="'text-right'"
                           [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"></vss-ui-range-number>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <input
        type="text" vssUiTrimSpaceInput nz-input
        [(ngModel)]="controlValue" (ngModelChange)="onModelChange($event)"
        [placeholder]="field.placeholder || field.label" [attr.maxlength]="MAX_LENGTH_TEXT"
        vssUiAutoCplControl [vssUiAutocomplete]="field.field" #inputDefaultRef
        (keyup.enter)="emitEvent(keyupEnter, $event)"/>
    </ng-container>
  </ng-container>
</ng-template>
